import { MobileDrawer } from '@v2/mobile/MobileDrawer/MobileDrawer';
import { Button } from '@v2/components/ui/button';
import { DeleteCommentModalProps } from './types';

export const MobileDeleteCommentModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading
}: DeleteCommentModalProps) => {
  return (
    <MobileDrawer
      isOpen={isOpen}
      onOpenChange={onClose}
      size="fit"
      dismissible={true}
    >
      <div className="p-6">
        <h3 className="mb-4 font-semibold text-gray-900 text-lg">
          Delete Comment
        </h3>
        <p className="mb-6">
          Are you sure you want to delete this comment? This action cannot be
          undone.
        </p>
        <div className="flex flex-col space-y-3">
          <Button
            onClick={onConfirm}
            variant="destructive"
            disabled={isLoading}
            className="flex-1"
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </Button>
          <Button onClick={onClose} variant="outline" className="flex-1">
            Cancel
          </Button>
        </div>
      </div>
    </MobileDrawer>
  );
};
